import { Sparkles } from 'lucide-react';
import { useParams } from '@tanstack/react-router';
import { CreateInterviewTypeVersionFormContainer } from '../../contexts/interview-types';

export function InterviewTypeEditPage() {
  const { interviewTypeId } = useParams({
    from: '/authenticated/orgs/$orgSlug/templates/$interviewTypeId/edit',
  });

  return (
    <div className="space-y-6">
      <header className="space-y-1.5">
        <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground">
          <Sparkles className="h-3.5 w-3.5" strokeWidth={2} />
          New version
        </div>
        <h1 className="text-[22px] font-semibold leading-tight tracking-tight text-foreground">
          Edit interview template
        </h1>
        <p className="text-[13.5px] leading-relaxed text-muted-foreground max-w-2xl">
          Versions are immutable — your changes create a new active version. The template name and
          description stay as they were.
        </p>
      </header>

      <CreateInterviewTypeVersionFormContainer interviewTypeId={interviewTypeId} />
    </div>
  );
}
